/**
 * Using a proper type guard (instead of taking a shortcut and relying on implicit coercion) helps TypeScript pick this specific overload.
 * Array.prototype.filter has a few overloads. One of them understands that the return value will depend on your predicate function. It uses a type guard:
 * filter<S extends T>(callbackfn: (value: T, index: number, array: T[]) => value is S, thisArg?: any): S[];
 */
export const isDefined = <T>(argument: T | undefined | null): argument is T =>
  argument !== undefined || argument !== null;

export const removeLeadingZeros = (val: string) => val.replace(/^0+/, '');
